'use client';

import { cn } from '@shared/components/shadcn';
import type { ReactNode } from 'react';
import type { StatusNotificationVariant } from '../../StatusNotification/types';
import { useIsAccountSuspended } from '../hooks/useIsAccountSuspended';
import { SuspendedNotificationWarning } from '../SuspendedNotification/SuspendedNotificationWarning';

type AccountSuspensionGateProps = {
  namespace: string;
  variant?: StatusNotificationVariant;
  className?: string;
  children: ReactNode;
  dataTrackType?: string;
  dataTrackMessage?: string;
  buttonText?: string;
  buttonTrackName?: string;
  buttonTestId?: string;
  onButtonClick?: () => void;
};

function AccountSuspensionGate({
  namespace,
  variant,
  className,
  children,
  dataTrackType,
  dataTrackMessage,
  buttonText,
  buttonTrackName,
  buttonTestId,
  onButtonClick,
}: AccountSuspensionGateProps) {
  return useIsAccountSuspended() ? (
    <div className={cn(className)}>
      <SuspendedNotificationWarning
        namespace={namespace}
        variant={variant}
        dataTrackType={dataTrackType}
        dataTrackMessage={dataTrackMessage}
        buttonText={buttonText}
        buttonTrackName={buttonTrackName}
        buttonTestId={buttonTestId}
        onButtonClick={onButtonClick}
      />
    </div>
  ) : (
    children
  );
}

export { AccountSuspensionGate, type AccountSuspensionGateProps };
